import { UserForm } from "@app/components/user-form";
import { useParams } from "react-router-dom";

export default function UserPage() {
  const params = useParams();
  return <UserForm id={params.id!!} />;
}
